<template>
  <FilterOverview :showFilterInitially="false" title="Aufpreisrechner">
    <template #table="{ tableHeight }">
      <div class="d-flex w-100 justify-content-center">
        <div v-if="isLoading"><b-spinner label="Spinning"></b-spinner></div>
        <div class="card p-4" v-else-if="!reisetermin">
          <h5>Reisetermin nicht gefunden!</h5>
        </div>
        <div class="card card-body" style="max-width: 850px" v-else>
          <div class="text-center">
            <h3>{{ reisetermin?.reise?.reisekuerzel }} - {{ startdatum }}</h3>
          </div>
          <div class="d-flex mt-2" style="justify-content: flex-end" v-if="hasSpecificStatus">
            <b-button variant="primary" size="sm" @click="openAirlineExcel">Airline-Infos</b-button>
          </div>

          <div class="d-flex align-items-center mt-10" style="gap: 8px">
            <h5 class="m-0">Fluginformationen</h5>
            <b-badge
              class="bigger-font"
              style="height: 32px; display: flex; justify-content: center; align-items: center"
              :variant="isRes ? 'danger' : ''"
            >
              {{ einkaufsart }}
            </b-badge>
          </div>
          <div class="p-2 bigger-font" style="display: flex; gap: 12px">
            <table style="border-radius: 8px">
              <tr v-for="(item, i) in fluginformationenTableDefinition" :key="'tableRow-' + i">
                <td
                  v-for="(cell, j) in item"
                  :key="'tableRow-' + i + '_tableCell-' + j"
                  :style="cell.style"
                  :class="cell.class"
                >
                  <span v-if="cell.html" v-html="cell.string"></span>
                  <span v-else>{{ cell.string }}</span>
                </td>
              </tr>
            </table>
          </div>
          <span v-if="isRes">
            <h5>
              <b-badge variant="danger" class="ml-2">Nur {{ einkaufsart }} erlaubt!</b-badge>
            </h5>
          </span>
          <div class="d-flex align-items-center mt-6" style="gap: 8px">
            <h5 class="m-0">Wunschverbindung</h5>
          </div>
          <div class="p-2 bigger-font" style="display: flex; gap: 12px">
            <table style="border-radius: 8px">
              <tr>
                <td></td>
                <td class="" style="font-weight: bold">Hinflug</td>
                <td class="" style="font-weight: bold">Rückflug</td>
              </tr>
              <tr>
                <td class="row-description">Ankunft / Abflug</td>
                <td
                  :style="{
                    backgroundColor: backgroundColorAnkunft,
                  }"
                >
                  <DatePicker
                    v-model="ankunft"
                    type="datetime"
                    format="DD.MM.YYYY HH:mm"
                    :popup-style="{ top: '100%', left: 0 }"
                    :append-to-body="false"
                    :default-value="defaultValueAnkunft"
                    :lang="langConfig"
                  />
                </td>
                <td
                  :style="{
                    backgroundColor: backgroundColorAbflug,
                  }"
                >
                  <DatePicker
                    v-model="abflug"
                    type="datetime"
                    format="DD.MM.YYYY HH:mm"
                    :popup-style="{ top: '100%', left: 0 }"
                    :append-to-body="false"
                    :default-value="defaultValueAbflug"
                    :lang="langConfig"
                  />
                </td>
              </tr>
              <tr>
                <td class="row-description">Vorverlängerung / Verlängerung</td>
                <td>
                  <AppSelect
                    v-model="vorverlaengerungSelected"
                    :options="vorverlaengerungOptions"
                    label="Vorverlängerung"
                    hide-search
                    class="aufpreis-select"
                    style="width: 210px"
                  />
                </td>
                <td>
                  <b-button
                    size="sm"
                    class="mr-1 bigger-font"
                    @click="verlaengerungSelected = true"
                    :variant="verlaengerungSelected === true ? 'primary' : ''"
                  >
                    Ja
                  </b-button>
                  <b-button
                    size="sm"
                    class="bigger-font"
                    @click="verlaengerungSelected = false"
                    :variant="verlaengerungSelected === false ? 'primary' : ''"
                  >
                    Nein
                  </b-button>
                </td>
              </tr>
            </table>
          </div>
          <div class="p-2 mt-6 bigger-font">
            <table>
              <tr>
                <td class="row-description">EK p.P.</td>
                <td
                  :style="{
                    backgroundColor:
                      einkaufspreisProPerson == null || einkaufspreisProPerson == ''
                        ? '#F64E6050'
                        : '#1BC5BD50',
                  }"
                >
                  <b-input-group size="sm" append="€" style="width: 210px">
                    <b-form-input
                      class="bigger-font"
                      v-model="einkaufspreisProPerson"
                      type="number"
                      step="1"
                      min="0"
                      :number="true"
                    />
                  </b-input-group>
                </td>
              </tr>
              <tr style="height: 35px">
                <td class="row-description">TH Langstrecke p.P.</td>
                <td>
                  <b-badge class="bigger-font">
                    {{ reisetermin?.thLangstrecke ? reisetermin?.thLangstrecke + ' €' : '-' }}
                  </b-badge>
                </td>
              </tr>
              <tr style="height: 35px">
                <td class="row-description">VK Flug(auf)preis p.P.</td>
                <td>
                  <div class="d-flex">
                    <b-badge
                      :style="verkaufspreisProPerson ? 'font-size: 1.1rem; font-weight: bold' : ''"
                      :variant="verkaufspreisProPerson ? 'warning' : 'secondary'"
                    >
                      {{ verkaufspreisProPerson ? verkaufspreisProPerson + ' €' : '-' }}
                    </b-badge>
                    <b-badge
                      v-if="verkaufspreisProPerson"
                      v-b-popover.hover="verkaufspreisProPersonTerm()"
                      style="display: flex; justify-content: center; align-items: center"
                      class="ml-auto"
                    >
                      <i class="fas fa-info btn-secondary"></i>
                    </b-badge>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="mt-6 d-flex" style="gap: 8px">
            <div v-if="vorverlaengerung == null">
              <h5>
                <b-badge variant="danger">
                  {{ hinweisVorverlaengerungPflege }}
                </b-badge>
              </h5>
            </div>
            <div v-if="vorverlaengerungSelected > 0">
              <h5>
                <b-badge variant="danger">Sondertransfer Hin separat buchen!</b-badge>
              </h5>
            </div>
            <div v-if="verlaengerungSelected === true">
              <h5>
                <b-badge variant="danger">Sondertransfer Rück separat buchen!</b-badge>
              </h5>
            </div>
          </div>
          <div class="mt-1" v-if="verkaufspreisProPerson != null">
            <h5>
              <b-badge>
                <span v-html="labelAufpreisbadge"></span>
              </b-badge>
            </h5>
          </div>
        </div>
      </div>
    </template>
  </FilterOverview>
</template>
<script>
import FilterOverview from '@/components/common/filter-overview.vue';
import AppSelect from '@/components/common/app-select/app-select.vue';
import * as odataService from '@/core/common/services/odata.service';
import { add, format, isAfter, isBefore, isWithinInterval, setHours, setMinutes, sub } from 'date-fns';
import DatePicker from 'vue2-datepicker';
import {
  buildFluginformationen,
  buildFluginformationenZeilen,
  joinGruppeneinkaufWerte,
} from '@/components/produkte/reisetermine/helpers/fluginformationen';
const moment = require('moment');

export default {
  components: {
    FilterOverview,
    DatePicker,
    AppSelect,
  },
  data() {
    return {
      isLoading: false,
      reisetermin: null,
      fluginformationenTableDefinition: null,
      ankunft: null,
      abflug: null,
      vorverlaengerungSelected: 0,
      verlaengerungSelected: false,
      hinweisVorverlaengerungPflege: '"Vorverlängerung" in Reisestammdaten pflegen!',
      einkaufspreisProPerson: null,
      langConfig: {
        formatLocale: {
          months: moment.localeData().months(),
          monthsShort: moment.localeData().monthsShort(),
          weekdays: moment.localeData().weekdays(),
          weekdaysShort: moment.localeData().weekdaysShort(),
          weekdaysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
          firstDayOfWeek: 1,
        },
      },
    };
  },
  async mounted() {
    if (this.$route.query.reiseterminId) {
      const { reiseterminId } = this.$route.query;
      this.isLoading = true;
      this.reisetermin = await this.getReisetermin(reiseterminId);

      this.fluginformationenTableDefinition = buildFluginformationenZeilen(this.fluginformationen);
      if (!this.isRes) {
        this.fluginformationenTableDefinition.push([
          { string: 'Vorverlängerung', style: '', class: 'row-description' },
          { string: this.fluginformationen.vorverlaengerung, style: '', class: '' },
          { string: '', style: '', class: '' },
        ]);
      }

      if (!['EP', '-'].includes(this.einkaufsart)) {
        this.fluginformationenTableDefinition.push(
          [
            { string: 'GRP FH', style: '', class: 'row-description' },
            { string: this.gruppeFlughafen, style: '', class: '', html: true },
            { string: '', style: '', class: '' },
          ],
          [
            { string: 'Flugnr. GRP', style: '', class: 'row-description' },
            { string: this.flugnummerGruppeHin, style: '', class: '', html: true },
            { string: this.flugnummerGruppeRueck, style: '', class: '', html: true },
          ],
          [
            { string: 'GRP PNR', style: '', class: 'row-description' },
            { string: this.gruppePnr, style: '', class: '', html: true },
            { string: '', style: '', class: '' },
          ]
        );
      }
      this.isLoading = false;
    }
  },
  computed: {
    labelAufpreisbadge() {
      const tsHin = this.transferszenarioHin?.substring(0, 2);
      const t4Label =
        'VK gilt nur für den Flug! Kein Transfer inklusive. Bitte VK Flug(auf)preis und Flug-EK in die BLANK Buchung setzen. <br/>Ggf. separaten Transfer buchen!';
      const txLabel =
        'VK gilt nur für den Flug! Kein Transfer inklusive. Bitte VK Flug(auf)preis und Flug-EK in die BLANK Buchung setzen.';
      const standardLabel =
        'Bitte VK Flug(auf)preis und Flug-EK in die BLANK Buchung setzen. Transfer-EK folgt durch DOM.';
      return tsHin === 'T4' ? t4Label : tsHin === 'TX' ? txLabel : standardLabel;
    },
    backgroundColorAnkunft() {
      if (this.vorverlaengerungSelected !== 0) return;
      return this.ankunft == null || this.ankunftNotInInterval ? '#F64E6050' : '#1BC5BD50';
    },
    backgroundColorAbflug() {
      if (this.verlaengerungSelected === true) return;

      return this.abflug == null || this.abflugNotInInterval ? '#F64E6050' : '#1BC5BD50';
    },
    verkaufspreisProPerson() {
      if (this.reisetermin) {
        const isFern = !['Dach', 'Südeuropa', 'Nordeuropa'].includes(this.reisetermin?.reise?.region);
        const vkKalkVornacht = this.beruecksichtigeVkKalkVornacht
          ? Math.round((this.reisetermin.metadata.vkVornachtDzProPerson ?? 0) * 10) / 10
          : 0;
        const vorverlaengerungOrAnkunftValid =
          this.vorverlaengerungSelected > 0 || (this.ankunft && !this.ankunftNotInInterval);
        const verlaengerungOrAbflugValid =
          this.verlaengerungSelected || (this.abflug && !this.abflugNotInInterval);
        const multiplier = isFern ? 0.74 : 0.76;
        if (
          vorverlaengerungOrAnkunftValid &&
          verlaengerungOrAbflugValid &&
          this.einkaufspreisProPerson != null &&
          this.einkaufspreisProPerson != ''
        ) {
          const roundedVk = Math.round(
            (this.einkaufspreisProPerson - (this.reisetermin.thLangstrecke ?? 0)) / multiplier +
              vkKalkVornacht
          );
          const minZero = roundedVk < 0 ? 0 : roundedVk;
          return minZero.toString().replaceAll('.', ',');
        }
      }
      return null;
    },

    ankunftNotInInterval() {
      if (
        this.ankunft != null &&
        (!isAfter(add(this.ankunft, { minutes: 1 }), this.fruehesteAnkunftDate) ||
          !isBefore(sub(this.ankunft, { minutes: 1 }), this.spaetesteAnkunftDate))
      ) {
        return true;
      }

      return false;
    },
    abflugNotInInterval() {
      if (
        this.abflug != null &&
        (!isAfter(add(this.abflug, { minutes: 1 }), this.fruehesterAbflugDate) ||
          !isBefore(sub(this.abflug, { minutes: 1 }), this.spaetesterAbflugDate))
      ) {
        return true;
      }

      return false;
    },
    ankunftBeforeThree() {
      if (this.ankunft != null && this.fruehesteAnkunftDate != null && this.spaetesteAnkunftDate != null) {
        const timeToCheckFirstDay = setMinutes(setHours(this.fruehesteAnkunftDate, 3), 0);
        const timeToCheckSecondDay = setMinutes(setHours(this.spaetesteAnkunftDate, 3), 0);
        const interval = {
          start: this.fruehesteAnkunftDate,
          end: this.spaetesteAnkunftDate,
        };

        const isThreeOClockInIntervalFirstDay = isWithinInterval(timeToCheckFirstDay, interval);
        if (isThreeOClockInIntervalFirstDay) {
          return isWithinInterval(this.ankunft, {
            start: this.fruehesteAnkunftDate,
            end: timeToCheckFirstDay,
          });
        }

        const isThreeOClockInIntervalSecondDay = isWithinInterval(timeToCheckSecondDay, interval);
        if (isThreeOClockInIntervalSecondDay) {
          return isWithinInterval(this.ankunft, {
            start: this.fruehesteAnkunftDate,
            end: timeToCheckSecondDay,
          });
        }
      }

      return false;
    },
    startdatum() {
      if (!this.reisetermin) return '';
      return format(new Date(this.reisetermin?.startdatum), 'dd.MM.yyyy');
    },
    fluginformationen() {
      return buildFluginformationen(this.reisetermin);
    },
    einkaufsart() {
      return this.fluginformationen.einkaufsart;
    },
    vorverlaengerung() {
      return this.fluginformationen.vorverlaengerung;
    },
    // Auswahl von 0 bis zur gepflegten Anzahl an Vorverlängerungsnächten
    vorverlaengerungOptions() {
      const anzahl = this.vorverlaengerung ? this.vorverlaengerung + 1 : 1;
      return Array.from({ length: anzahl }, (wert, index) => ({ value: index, text: String(index) }));
    },
    transferszenarioHin() {
      return this.fluginformationen.transferszenarioHin;
    },
    fruehesteAnkunftDate() {
      return this.fluginformationen.fruehesteAnkunftDate;
    },
    fruehesterAbflugDate() {
      return this.fluginformationen.fruehesterAbflugDate;
    },
    spaetesteAnkunftDate() {
      return this.fluginformationen.spaetesteAnkunftDate;
    },
    spaetesterAbflugDate() {
      return this.fluginformationen.spaetesterAbflugDate;
    },
    defaultValueAnkunft() {
      if (!this.fruehesteAnkunftDate) return '-';

      return this.fruehesteAnkunftDate;
    },
    defaultValueAbflug() {
      if (!this.fruehesterAbflugDate) return '-';

      return this.fruehesterAbflugDate;
    },
    gruppeFlughafen() {
      return joinGruppeneinkaufWerte(this.reisetermin, 'flughafenIataCode');
    },
    flugnummerGruppeHin() {
      return joinGruppeneinkaufWerte(this.reisetermin, 'flugnummerGruppeHin');
    },
    flugnummerGruppeRueck() {
      return joinGruppeneinkaufWerte(this.reisetermin, 'flugnummerGruppeRueck');
    },
    gruppePnr() {
      return joinGruppeneinkaufWerte(this.reisetermin, 'gruppePnr');
    },
    isRes() {
      return ['RES', 'RES GRP'].includes(this.einkaufsart);
    },
    beruecksichtigeVkKalkVornacht() {
      return this.vorverlaengerungSelected === 0 && this.ankunftBeforeThree;
    },
    hasSpecificStatus() {
      return !['EP', '-'].includes(this.einkaufsart);
    },
  },
  methods: {
    verkaufspreisProPersonTerm() {
      if (this.reisetermin) {
        const isFern = !['Dach', 'Südeuropa', 'Nordeuropa'].includes(this.reisetermin?.reise?.region);
        const multiplier = isFern ? 0.74 : 0.76;
        const vkKalkVornacht = this.beruecksichtigeVkKalkVornacht
          ? Math.round((this.reisetermin.metadata.vkVornachtDzProPerson ?? 0) * 10) / 10
          : 0;

        return `((${this.einkaufspreisProPerson} € - ${
          this.reisetermin.thLangstrecke ?? 0
        } €) / ${multiplier}) ${vkKalkVornacht > 0 ? '+ ' + vkKalkVornacht + ' €' : ''}`.replaceAll('.', ',');
      }
      return null;
    },
    getReisetermin(reiseterminId) {
      const filter = { id: +reiseterminId };
      const expand = {
        reise: {},
        metadata: {
          expand: {
            ziellandAbflughaefen: {},
            ziellandZielflughaefen: {},
            inlandsfluege: {},
          },
        },
        flugeinkauf: { expand: { Gruppeneinkaeufe: {} } },
      };
      return odataService.getReisetermin({ filter, expand }).then(res => res.data[0]);
    },
    openAirlineExcel() {
      window.open(
        'https://skrreisengmbh.sharepoint.com/:x:/s/YieldControlling/IQBx61XLPgNdQJpqWXBOSBKnAXv8dheyuQ27PUKpkIfK6IU?e=cBQMUR&isSPOFile=1&wdExp=TEAMS-TREATMENT&web=1&CID=a859f5af-713f-b459-114d-0881d40fb776&clickParams=eyJYLUFwcE5hbWUiOiJNaWNyb3NvZnQgT3V0bG9vayBXZWIgQXBwIiwiWC1BcHBWZXJzaW9uIjoiMjAyNjA3MjQwMDMuMTEiLCJPUyI6IldpbmRvd3MgMTEifQ%3D%3D',
        '_blank'
      );
    },
  },
};
</script>
<style scoped>
td {
  padding: 4px 8px;
  width: 250px;
}

tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.row-description {
  background-color: var(--border);
}

.bigger-font {
  font-size: 1.1rem;
}

.form-control {
  border: 1px solid #ccc;
}

.aufpreis-select {
  --app-select-border-color: #ccc;
  --app-select-font-size: 1.1rem;
}
</style>
